'use client';

import { useContext, type FC } from 'react';
import { QuestionnairePreview } from '@/_components/QuestionnairePreview';
import type { QuestionnairePreviewDialogProps } from './QuestionnairePreviewDialog.types';
import { QuestionnaireContext } from '@/_contexts/admin/QuestionnaireProvider';

export const QuestionnairePreviewDialog: FC<
  QuestionnairePreviewDialogProps
> = ({ isOpen, onClose }) => {
  const {
    highlightedQuestionIds,
    isBulkUploadProcessing,
    setIsBulkUploadProcessing,
    isBUPReviewDialogOpenForSource,
    shouldAutoOpenBUPOnPreview,
    isLoadingQuestionnairePreview,
    setLoading,
    questionnairePreview,
    questionnairePreviewCompany,
    onExportToggle,
    reloadQuestionnairePreview,
    loadQuestionnaires,
    setQuestionnaireExport,
    setIsBUPReviewDialogOpenForSource,
    setShouldAutoOpenBUPOnPreview,
  } = useContext(QuestionnaireContext);

  return (
    <QuestionnairePreview
      isOpen={isOpen}
      onClose={onClose}
      questionnaire={questionnairePreview}
      questionnaireCompany={questionnairePreviewCompany}
      isQuestionnaireLoading={isLoadingQuestionnairePreview}
      isBulkUploadProcessing={isBulkUploadProcessing}
      isBUPReviewDialogOpenForSource={isBUPReviewDialogOpenForSource}
      setLoading={setLoading}
      reloadQuestionnairePreview={reloadQuestionnairePreview}
      loadQuestionnaires={loadQuestionnaires}
      onExportToggle={onExportToggle}
      setQuestionnaireExport={setQuestionnaireExport}
      highlightedQuestionIds={highlightedQuestionIds}
      setIsBulkUploadProcessing={setIsBulkUploadProcessing}
      setIsBUPReviewDialogOpenForSource={setIsBUPReviewDialogOpenForSource}
      setShouldAutoOpenBUPOnPreview={setShouldAutoOpenBUPOnPreview}
      shouldAutoOpenBUPOnPreview={shouldAutoOpenBUPOnPreview}
    />
  );
};
